import { useWebStoreContext } from "contexts";
import { useEnvContext } from "contexts/EnvProvider";
import { FeaturesFlags } from "helpers";
import useLiveopsConfigs from "hooks/useLiveopsConfigs";
import { userSegmentsApi } from "redux/apis";

export const useEliteDealsAccess = (): boolean => {
	const { authToken, userTracker } = useWebStoreContext();
	const { isFeatureFlagEnabled } = useEnvContext();
	const configs = useLiveopsConfigs(["elite_segment_id"]);
	const userId = userTracker?.id;
	// Only read from cache without triggering new requests
	const { data: segmentsData } =
		userSegmentsApi.endpoints.getUserSegments.useQueryState(userId);

	if (!isFeatureFlagEnabled(FeaturesFlags.ELITE)) {
		return false;
	}

	if (!authToken?.value || !userId) {
		return false;
	}

	if (!segmentsData) {
		return false;
	}

	const requiredSegment = configs.elite_segment_id?.trim();
	if (!requiredSegment) {
		return false;
	}

	return segmentsData.segmentIds.includes(requiredSegment);
};
